import { render, staticRenderFns } from "./AssignParentModal.vue?vue&type=template&id=dce140fe"
import script from "./AssignParentModal.vue?vue&type=script&lang=js"
export * from "./AssignParentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports